const t = {
  name: "BusinessShirt",
  dimensions: { width: 41, height: 40 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4746)">
    <path d="M38.0024 37.5029H21.0024V12.8429L29.7124 15.4529C30.3524 15.6529 31.0024 15.1729 31.0024 14.5029V6.75293L37.2224 8.13293C37.6724 8.23293 38.0024 8.64293 38.0024 9.10293V37.5029ZM2.00244 8.30293L9.00244 6.74293V14.5029C9.00244 15.1729 9.65244 15.6529 10.2924 15.4629L19.0024 12.8429V37.5029H3.00244C2.45244 37.5029 2.00244 37.0529 2.00244 36.5029V8.30293ZM29.0024 3.91293V13.1529L21.8924 11.0229L29.0024 3.91293ZM12.4124 2.50293H26.3724C26.8224 2.50293 27.0424 3.04293 26.7224 3.35293L20.0024 10.0929L12.4124 2.50293ZM11.0024 3.91293L18.1124 11.0229L11.0024 13.1629V3.91293ZM38.4324 6.35293L31.0024 4.70293V2.50293C31.0024 1.40293 30.1024 0.50293 29.0024 0.50293H11.0024C9.90244 0.50293 9.00244 1.40293 9.00244 2.50293V4.70293L1.57244 6.35293C0.652441 6.55293 0.00244141 7.37293 0.00244141 8.30293V37.5029C0.00244141 38.6029 0.902441 39.5029 2.00244 39.5029H38.0024C39.1024 39.5029 40.0024 38.6029 40.0024 37.5029V8.30293C40.0024 7.37293 39.3524 6.55293 38.4324 6.35293Z" />
    <path d="M26.0024 22.5029C25.4524 22.5029 25.0024 22.9529 25.0024 23.5029C25.0024 24.0529 25.4524 24.5029 26.0024 24.5029H33.0024C33.5524 24.5029 34.0024 24.0529 34.0024 23.5029C34.0024 22.9529 33.5524 22.5029 33.0024 22.5029H26.0024Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4746">
    <rect width="40" height="39" fill="currentColor" transform="translate(0.00244141 0.50293)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  t as BusinessShirt
};
